import axios from 'axios'

const API_BASE = process.env.REACT_APP_HOST + '/api/v1/quiz'

export async function getQuizQuestions(sessionId) {
  const response = await axios.get(`${API_BASE}/questions/${sessionId}`)
  return response.data
}

export async function checkQuizCompleted(userId, sessionId, quizType) {
  const response = await axios.get(`${API_BASE}/check/${userId}/${sessionId}/${quizType}`)
  return response.data
}

export async function submitQuiz(userId, sessionId, quizType, responses) {
  const response = await axios.post(`${API_BASE}/submit`, {
    userId,
    sessionId,
    quizType,
    responses
  })
  return response.data
}